import { windowWrapper } from '@clubmed/utils';
import logger from 'Logger';
import type { StoreActionMeta } from 'Store/utils/createAction';
import * as pleUtils from 'Utils/ple-utils';

type ActionWithMeta = (Action<unknown> | OptimisticAction<unknown, unknown>) & {
  meta?: StoreActionMeta;
};

export function createAuthenticationMiddleware() {
  return () => (next: any) => (action: Action<any> | OptimisticAction<any, any>) => {
    try {
      // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
      const redirectUri = (action as ActionWithMeta).meta?.redirect_uri;

      if (!!redirectUri && pleUtils.hasAuthResponseError(action.payload)) {
        windowWrapper.setLocation(redirectUri);
      }
    } catch (e) {
      logger.warn(e);
    }

    return next(action);
  };
}
